<template>
  <div id="page-consulter-partner">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="6em">
      <el-row>
        <el-form-item prop="regionId" label="Region" required>
          <filter-businessline-region :value.sync="searchForm.regionId" businessLine="2" required />
        </el-form-item>
        <el-form-item label="日期" required>
          <filter-date-range :value.sync="dateRange" :range="90" :init-range="7" required />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="handleQuery(true)">查询</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <section class="data-container">
      <common-report-table
        ref="table"
        url="getGenericData"
        tableAlign="center"
        :type="2"
        :showHeaderTip="true"
        :filterParams="filterParams"
      />
    </section>
  </div>
</template>

<script>
import { dateFormat } from '@/utils'

export default {
  data() {
    return {
      dateRange: [],
      searchForm: {
        date: '',
        endDate: '',
        regionId: '',
        partnerType: 2,
      },
    }
  },

  computed: {
    filterParams() {
      return {
        pageId: 'city_operation_data_type_3',
        date: dateFormat(this.dateRange[0]),
        endDate: dateFormat(this.dateRange[1]),
        regionIdList: this.searchForm.regionId ? [this.searchForm.regionId] : [],
      }
    },
  },

  methods: {
    handleQuery(init = false) {
      if (!this.searchForm.regionId) {
        this.$message.error('Region不能为空!')
        return
      }
      this.$refs.table && this.$refs.table.fetchData(init, this.filterParams)
    },
  },
}
</script>
